export interface ICampaign {
  _id: string;
  name: string;
  description?: string;
  date: string; // ISO 8601 format
  model: string;
  audienceType: 'leads' | 'renters' | '';
  targetAudience?: string[];
  sentCount: number;
  status: 'pending' | 'sending' | 'sent';
  renterStatus?: string[];
  renterSituation?: string[];
}

export const CAMPAING_STATUS = {
  "pending": "Pendente", 
  "sent": "Enviada", 
  "sending": "Enviando",
  "failed": "Falhou"
}
